module.exports = __webpack_public_path__ + "img/logo.a521f7ee.png";